'use client';

import { c as _c } from "react/compiler-runtime";
import { CursorProvider } from './CursorContext';
import { useEffect } from 'react';
import useCustomCursorEnabled from '@/src/hooks/useCustomCursorEnabled';
import Cursor from './Cursor';
const CursorLayout = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const isCursorEnabled = useCustomCursorEnabled();
  let t1;
  let t2;
  if ($[0] !== isCursorEnabled) {
    t1 = () => {
      if (isCursorEnabled) {
        document.body.classList.add("custom-cursor-enabled");
      } else {
        document.body.classList.remove("custom-cursor-enabled");
      }
      return _temp;
    };
    t2 = [isCursorEnabled];
    $[0] = isCursorEnabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isCursorEnabled) {
    t3 = <Cursor isEnabled={isCursorEnabled} />;
    $[3] = isCursorEnabled;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <CursorProvider>{children}{t3}</CursorProvider>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default CursorLayout;
function _temp() {
  document.body.classList.remove("custom-cursor-enabled");
}